export default __webpack_public_path__ + "static/media/graignes12.6916c64d.jpg";